import { render, staticRenderFns } from "./AppointmentAccept.vue?vue&type=template&id=3b081f10&scoped=true&"
import script from "./AppointmentAccept.vue?vue&type=script&lang=js&"
export * from "./AppointmentAccept.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentAccept.vue?vue&type=style&index=0&id=3b081f10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b081f10",
  null
  
)

export default component.exports